export default "__VITE_ASSET__BxYQoqiy__"